import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ButtonShape, ButtonSizes } from '~src/shared/buttons/basicButtons/BaseButton.sc';
import SecondaryButton from '~src/shared/buttons/basicButtons/SecondaryButton.sc';
import HoverInfoIcon from '~src/shared/tooltips/HoverInfoIcon';
import { SubObjectiveItem } from '~src/store/okrs/interfaces';
import EditSubobjectiveItem from '~src/modules/okrs/manageObjectives/edit/subObjective/EditSubObjectiveItem';
import SelectorHandler from '~src/modules/okrs/manageObjectives/shared/SelectorHandler';
import { CapitalizeFirst, SubObjectivesList, Title } from '~src/modules/okrs/manageObjectives/shared/shared.sc';
import Dialog from '~src/shared/dialogs/dialog/Dialog';
import AddSubobjectiveForm from '~src/modules/okrs/manageObjectives/edit/subObjective/AddSubobjectiveForm';

interface OwnProps {
  subobjectives: SubObjectiveItem[];

  unlinkSubobjective(objectiveId: string): void;

  addSubObjective(subobjectiveId: string, weighting: number | null): void;
}

const SubobjectivesList: FC<OwnProps> = props => {
  const [t] = useTranslation();
  const [selectedSubobjective, setSelectedSubobjective] = useState<SubObjectiveItem | null>(null);

  const [addModalActive, setAddModalActive] = useState(false);
  const showAddModal = () => setAddModalActive(true);
  const hideAddModal = () => {
    setSelectedSubobjective(null);
    setAddModalActive(false);
  };
  const hideEditModal = () => {
    setSelectedSubobjective(null);
  };

  const addSubobjective = (subObjectiveId: string, weighting: number | null) => {
    props.addSubObjective(subObjectiveId, weighting);
    hideEditModal();
    hideAddModal();
  };

  const onAddClick = (e: Event) => {
    e.preventDefault();
    e.stopPropagation();
    showAddModal();
  };

  return (
    <>
      <Dialog show={addModalActive || !!selectedSubobjective} onHide={hideAddModal}>
        {(addModalActive || selectedSubobjective) && (
          <AddSubobjectiveForm
            subobjective={selectedSubobjective}
            addSubobjective={addSubobjective}
            disallowedIds={props.subobjectives.map(o => o.id)}
            hide={hideAddModal}
          />
        )}
      </Dialog>
      <SelectorHandler iconName="iconPlusBox" hoverTextKey="x.objective.sub-objectives.title.text">
        {() => (
          <>
            <Title $active className="sub_title">
              <span data-translation={'x.objective.sub-objectives.title.text'}>
                {t('x.objective.sub-objectives.title.text')}
              </span>
              <HoverInfoIcon
                infoText={{
                  key: 'x.objective.sub-objectives.title.help',
                  txt: t('x.objective.sub-objectives.title.help'),
                }}
              />
            </Title>

            <SubObjectivesList>
              {props.subobjectives.map((objective, k) => (
                <EditSubobjectiveItem
                  key={k}
                  objective={objective}
                  readonly={false}
                  unlinkSubobjective={props.unlinkSubobjective}
                  creationMode
                  setSelectedSubobjective={setSelectedSubobjective}
                />
              ))}
            </SubObjectivesList>
            <SecondaryButton
              onClick={onAddClick}
              $buttonSize={ButtonSizes.Medium}
              $buttonShape={ButtonShape.Oval}
              style={{ margin: '10px 0' }}
            >
              <CapitalizeFirst data-translation="x.objective.sub-objectives.add.text">
                {t('x.objective.sub-objectives.add.text')}
              </CapitalizeFirst>
            </SecondaryButton>
          </>
        )}
      </SelectorHandler>
    </>
  );
};
export default SubobjectivesList;
